import { AppThunk } from '../../../store/rootReducer';
import * as AnnotationTaskClient from '../clients/annotation-task.client';
import * as adminActions from '../actions/admin.actions';
import { displayNotification } from '../../../shared/notification/display-notification';
import { AnnotationTask } from '../../ecg/types/annotation-tasks.type';

export const updateAnnotation =
  (annotationTask: AnnotationTask, status: string): AppThunk =>
  async (dispatch) => {
    try {
      const task = await AnnotationTaskClient.updateStatus(
        annotationTask.id,
        status,
      );

      if (!task) {
        throw new Error(`An error occurred, please try again`);
      }

      dispatch(
        adminActions.update({
          annotationTask: annotationTask,
          status: status,
          meta: { history: false },
        }),
      );

      displayNotification({
        title: 'Success',
        description: 'The task has been updated successfully',
        status: 'success',
      });
    } catch (error) {
      displayNotification({
        title: 'Error',
        description: `${error}`,
        status: 'error',
      });
    }
  };
